import { IonButton, IonRouterLink } from '@ionic/react';
import React from 'react';

import { Browser } from '@capacitor/browser';

import { ButtonContainer, Spacer } from '@/components/common';
import { Text } from '@/components/memo';
import { useSubscription } from '@/contexts';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@/utils/constants';
import {
  PLAN_ORIGINAL_PRICES_STRING,
  PLAN_PRICES_STRING
} from '@/utils/subscriptions';

import './Buttons.css';

const Buttons: React.FC = () => {
  const { isEligibleForTrial, selectedPlan, purchase, restore } =
    useSubscription();

  const getPromptText = () => {
    if (isEligibleForTrial) {
      if (!selectedPlan) {
        return `₱${PLAN_PRICES_STRING.solo_monthly}/month — cancel anytime`;
      }

      return `₱${PLAN_PRICES_STRING[selectedPlan.identifier] ?? PLAN_PRICES_STRING.solo_monthly}/month — cancel anytime`;
    }

    return 'Subscribe to continue using Odonto.';
  };

  const getOriginalPrice = () => {
    return `₱${PLAN_ORIGINAL_PRICES_STRING[selectedPlan?.identifier ?? 'solo_monthly']}`;
  };

  const getButtonText = () => {
    if (isEligibleForTrial) {
      return 'Start 1-week free trial';
    }

    if (!selectedPlan) {
      return 'Continue';
    }

    return `₱${PLAN_PRICES_STRING[selectedPlan.identifier] ?? PLAN_PRICES_STRING.solo_monthly}/month`;
  };

  const onTerms = () => {
    Browser.open({ url: TERMS_OF_SERVICE_URL });
  };

  const onPrivacy = () => {
    Browser.open({ url: PRIVACY_POLICY_URL });
  };

  const copy = {
    restore: 'Restore',
    terms: 'Terms',
    privacy: 'Privacy'
  };

  return (
    <ButtonContainer translucent={false}>
      <p className="buttons__prompt">
        {isEligibleForTrial && (
          <Text className="buttons__prompt-accent">{getOriginalPrice()}</Text>
        )}
        {getPromptText()}
      </p>
      <Spacer top={8} />
      <IonButton
        id="next-button"
        onClick={purchase}
        expand="block"
        fill="solid"
        size="default"
        color="primary"
        strong={true}
      >
        {!isEligibleForTrial && (
          <Text className="buttons__button-accent">{getOriginalPrice()}</Text>
        )}
        {getButtonText()}
      </IonButton>
      <div className="buttons__links">
        <IonRouterLink id="restore-link" color="dark" onClick={restore}>
          {copy.restore}
        </IonRouterLink>
        <span>•</span>
        <IonRouterLink id="terms-link" color="dark" onClick={onTerms}>
          {copy.terms}
        </IonRouterLink>
        <span>•</span>
        <IonRouterLink id="privacy-link" color="dark" onClick={onPrivacy}>
          {copy.privacy}
        </IonRouterLink>
      </div>
    </ButtonContainer>
  );
};

export default Buttons;
